export const SET_GIFT_CARD = 'SET_GIFT_CARD';

export function setGiftCard(giftCard) {
  return {
    type: SET_GIFT_CARD,
    payload: giftCard,
  };
}
